module.exports = __webpack_public_path__ + "img/icon_huojian.a3bbab71.gif";